var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 4.1712V6.99963L15 6.9997L16.4142 5.58549L17.1213 2.04996L13.5858 2.75706L11.9997 4.1712Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 8L6.83099 8.39209L4.20599 11.8207L4 12.4286V17.5714L4.20599 18.1793L6.83099 21.6079L7.625 22H16.375L17.169 21.6079L19.794 18.1793L20 17.5714V12.4286L19.794 11.8207L17.169 8.39209L16.375 8H7.625ZM12.9162 20H15.8812L18 17.2326V12.7674L15.8812 10H12.9162L11 12.77V17.23L12.9162 20Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e6ce1e4891f3497c36c59d76cd390d04.svg";
export { ForwardRef as ReactComponent };